import React from "react";
import ashleyUpdatesVideo from "../../assets/mission-control/ashleyupdates.mp4";
import ringPng from "../../assets/mission-control/ring.png";
import "./VoiceGuidedFormOverlay.css";

const GUIDED_FORM_PHASE = Object.freeze({
  SPEAKING: "speaking",
  LISTENING: "listening",
  WAITING: "waiting",
  CONFIRMING: "confirming",
  PROCESSING: "processing",
});

export function VoiceGuidedFormOverlay({
  isActive,
  phase,
  statusMessage,
  interactionUI,
  onConfirmYes,
  onConfirmChooseAgain,
  onRecoveryAction,
}) {
  if (!isActive) {
    return null;
  }

  const isListening =
    phase === GUIDED_FORM_PHASE.LISTENING ||
    phase === GUIDED_FORM_PHASE.SPEAKING;

  const statusLabel =
    phase === GUIDED_FORM_PHASE.LISTENING
      ? interactionUI?.type === "recovery"
        ? "Recovery"
        : "Listening"
      : phase === GUIDED_FORM_PHASE.CONFIRMING
        ? "Confirm"
        : phase === GUIDED_FORM_PHASE.WAITING
          ? "Waiting"
          : "Ashley";

  return (
    <div className="voice-guided-form-overlay" aria-live="polite">
      <div className="voice-guided-form-overlay__content guide-ashley-listening-panel">
        <div className="guide-ashley-listening-figure" aria-hidden="true">
          <video
            autoPlay
            playsInline
            controls={false}
            muted
            loop
            className="ashley-voice-overlay__video"
          >
            <source src={ashleyUpdatesVideo} type="video/mp4" />
          </video>

          <img
            src={ringPng}
            alt=""
            aria-hidden="true"
            className={`ashley-voice-overlay__ring${
              isListening ? " ashley-voice-overlay__ring--listening" : ""
            }`}
          />
        </div>

        <div className="ashley-voice-overlay__status">
          <p className="ashley-voice-overlay__status-label">{statusLabel}</p>
          <p className="ashley-voice-overlay__status-message">{statusMessage}</p>
        </div>

        {interactionUI?.type === "confirm" ? (
          <div className="voice-guided-form-overlay__confirm-actions">
            <button
              type="button"
              className="voice-guided-form-overlay__confirm-btn voice-guided-form-overlay__confirm-btn--yes"
              onClick={onConfirmYes}
            >
              Yes
            </button>
            <button
              type="button"
              className="voice-guided-form-overlay__confirm-btn"
              onClick={onConfirmChooseAgain}
            >
              Choose Again
            </button>
          </div>
        ) : null}

        {interactionUI?.type === "recovery" ? (
          <div className="voice-guided-form-overlay__confirm-actions">
            {interactionUI.options.map((option) => (
              <button
                key={option.action}
                type="button"
                className="voice-guided-form-overlay__confirm-btn"
                onClick={() => onRecoveryAction?.(option.action)}
              >
                {option.label}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export { GUIDED_FORM_PHASE };
